import { NgModule } from '@angular/core';
import { ModelComponent } from './ModelComponent';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

/**
 * Create a list of all the components this module will offer
 */
export let MODEL_DECORATORS_ANGULAR2_COMPONENTS: Array<any> = [
	ModelComponent
]

/**
 * Build out the angular 2 module so that it can be plugged into other systems.
 */
@NgModule({
	imports: [ BrowserModule, FormsModule ],
	declarations: [ MODEL_DECORATORS_ANGULAR2_COMPONENTS ],
	exports: [ MODEL_DECORATORS_ANGULAR2_COMPONENTS ]
})
export class ModelDecoratorsAngular2Model { }